import PropTypes from 'prop-types';
import React from 'react';
import EditableField from './EditableField';
import InputSingleCalendar from '../calendar/InputSingleCalendar';
import Availability from '../../models/Availability';

export default class EditableDate extends EditableField {
    static propTypes = {
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        startOn: PropTypes.string,
        endOn: PropTypes.string,
        renderer: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
        inputType: PropTypes.oneOf(['start', 'end']).isRequired,
        availabilities: PropTypes.arrayOf(PropTypes.instanceOf(Availability)),
        validator: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.calendarRef = React.createRef();
        this.clickOutsideHandler = this.clickOutsideHandler.bind(this);
        this.selectedHandler = this.selectedHandler.bind(this);
    }

    componentDidUpdate() {
        if (this.state.editing) {
            this.showCalendar();
        }
    }

    isMobile() {
        return window.matchMedia ? window.matchMedia('(min-width: 768px)').matches === false : false;
    }

    showCalendar() {
        if (this.calendarRef.current) {
            this.calendarRef.current.showCalendar();
            // Kalendae uses offsetLeft which ignores translateX, we need to adjust the position
            if (
                window.matchMedia &&
                window.matchMedia('(max-width: 1199px)').matches &&
                window.matchMedia('(min-width: 768px)').matches
            ) {
                this.calendarRef.current.calendar.container.style.transform = `translateX(-${
                    document.body.offsetWidth - 30
                }px)`;
            } else {
                this.calendarRef.current.calendar.container.style.transform = '';
            }
        }
        setTimeout(() => {
            $(document).on('click touchend', this.clickOutsideHandler);
        }, 500);
    }

    hideCalendar() {
        if (this.calendarRef.current) {
            this.calendarRef.current.closeCalendar();
        }
        $(document).off('click touchend', this.clickOutsideHandler);
    }

    clickOutsideHandler(e) {
        // hide calendar when focus out
        if ($(e.target).closest('.kalendae').length === 0) {
            this.hideInput();
            this.hideCalendar();
        }
    }

    onSave() {
        this.hideCalendar();
        this.props.onChange(this.props.name, this.state.value);
        return true;
    }

    checkValidity() {
        return !this.props.validator || this.props.validator(this.state.value);
    }

    setValue(date) {
        this.setState(
            {
                value: moment(date).hours(0).minutes(0).seconds(0)
            },
            () => {
                this.save();
            }
        );
    }

    selectedHandler(date) {
        if (date[0]) {
            this.setValue(date[0]);
        }
    }

    renderInput() {
        const classname = ['editable-date-calendar'];

        if (this.isMobile()) {
            classname.push('editable-date-calendar-fullscreen');
        }

        return (
            <InputSingleCalendar
                ref={this.calendarRef}
                nbMonths={1}
                availabilities={this.props.availabilities}
                mode="single"
                startOn={this.props.startOn ? moment(this.props.startOn) : null}
                endOn={this.props.endOn ? moment(this.props.endOn) : null}
                classname={classname}
                selectedHandler={this.selectedHandler}
                side="left"
                inputType={this.props.inputType}
            />
        );
    }
}
